import { createUIStore } from '@splitfiesta/core';
import { webStorage, webThemeAdapter } from '@splitfiesta/platform-web';

export type { ExpenseFilterMode } from '@splitfiesta/core';

export const useUIStore = createUIStore({
  storage: webStorage,
  theme: webThemeAdapter,
});

export const useTheme = () => useUIStore(state => state.theme);
export const useEffectiveTheme = () =>
  useUIStore(state => state.effectiveTheme);
export const useThemeActions = () =>
  useUIStore(state => ({
    setTheme: state.setTheme,
    toggleTheme: state.toggleTheme,
  }));
export const useSidebarOpen = () => useUIStore(state => state.sidebarOpen);
export const useModals = () => useUIStore(state => state.modals);
export const useToasts = () => useUIStore(state => state.toasts);
export const useGlobalLoading = () => useUIStore(state => state.loading.global);
export const useActiveGroupId = () => useUIStore(state => state.activeGroupId);
export const useIsChangingRoute = () =>
  useUIStore(state => state.isChangingRoute);
export const useRouteChangeActions = () =>
  useUIStore(state => ({
    startRouteChange: state.startRouteChange,
    endRouteChange: state.endRouteChange,
  }));

export const useFormDraft = (formName: string) =>
  useUIStore(state => state.formDrafts[formName]);
export const useFormDraftActions = () =>
  useUIStore(state => ({
    saveFormDraft: state.saveFormDraft,
    loadFormDraft: state.loadFormDraft,
    clearFormDraft: state.clearFormDraft,
    clearAllDrafts: state.clearAllDrafts,
  }));

export const useActivityFilter = () =>
  useUIStore(state => state.activityFilter);
export const useSetActivityFilter = () =>
  useUIStore(state => state.setActivityFilter);

export const useExpensesFilter = () =>
  useUIStore(state => state.expensesFilter);
export const useSetExpensesFilter = () =>
  useUIStore(state => state.setExpensesFilter);
